import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.json.stringify.js";
import "regenerator-runtime/runtime.js";

/* this file is transformed by vux-loader */

/* eslint-disable */
import _createForOfIteratorHelper from "D:/we-dev/mobile_v2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/we-dev/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.json.stringify.js";
import "regenerator-runtime/runtime.js"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'StartWork',
  interval: '',
  components: {},
  props: {
    isFresh: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      showToast: false,
      currDate: '',
      weekcn: '',
      address: '定位中...',
      tip: '',
      control: '-1',
      points: [],
      signx: '',
      signy: '',
      range: '',
      userSerial: '',
      date: [{
        worktype: ''
      }],
      workData: [{
        time: '',
        status: 1,
        oktime: []
      }, {
        time: '',
        status: 0,
        oktime: []
      }],
      ifstart: [false, false],
      limitNum: 1,
      sourceType: ['camera'],
      imgList: [],
      attenceDetail: {},
      isChecked: false,
      //是否开启定位考勤
      show: false,
      msg: '考勤打卡成功!',
      time: '',
      locationId: '',
      userImage: '',
      sj: '',
      //时间考勤
      currentIndex: 0,
      itemObj: {
        sj: '',
        address: '',
        jing: "",
        wei: ''
      },
      setTimeer: null
    };
  },
  watch: {
    isFresh: {
      handler: function handler(newFresh) {
        if (newFresh) {
          this.onPosition();
          this.$emit('showFresh');
        }
      },
      deep: true
    }
  },
  methods: {
    jumpMapBig: function jumpMapBig() {
      this.$router.push({
        name: 'BdMap',
        params: {
          mapcontrol: 20,
          flag: false
        }
      });
    },
    getSysDate: function getSysDate() {
      var _this = this;

      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;
        _this.itemObj.sj = response.data.sysDate;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);
        } else {
          _this.currDate = data.sysDate;
          _this.weekcn = _this.$utils.DateUtils.getWeekCnThree(data.sysDate); // this.getToday();
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },
    getRange: function () {
      var _getRange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, code, msg, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.$utils.Tools.loadShow();
                _context.next = 4;
                return this.$api.Attence.getRange({
                  userSerial: this.userSerial
                });

              case 4:
                response = _context.sent;
                code = response.code, msg = response.msg, data = response.data;
                this.$utils.Tools.loadHide();

                if (+code !== this.$code.success) {
                  this.$utils.Tools.toastShow(msg);
                  this.tip = '请先在SCM电脑端设置考勤地点及范围';
                  this.control = '0';
                } else {
                  if (data.length === 0) {
                    this.tip = '请先在SCM电脑端设置考勤地点及范围';
                    this.control = '0';
                  } else {
                    this.points = data;
                  }
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                this.$utils.Tools.httpError();

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function getRange() {
        return _getRange.apply(this, arguments);
      }

      return getRange;
    }(),
    setConfig: function setConfig() {
      var _this2 = this;

      var localUrl = window.location.href.split('#')[0];
      this.$api.Sys.getConfig(localUrl, this.$params.mode).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);
        } else {
          _this2.$utils.WeiXin.wxConfig(data);

          setTimeout(function () {
            _this2.onPosition();
          }, 500);
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },
    onPosition: function onPosition() {
      var _this3 = this;

      this.$utils.Tools.loadShow('正在定位');
      var that = this;
      that.$utils.WeiXin.wxGetLocation('allmap', 14, false, function (resp) {
        _this3.$utils.Tools.loadHide();

        if (resp.flag === true) {
          that.address = resp.address;
          that.control = '0';
          that.$utils.Store.setItem('address', resp.address);
          that.$utils.Store.setItem('resp', JSON.stringify(resp));
          that.itemObj.address = that.address = resp.address;
          that.itemObj.jing = that.signx = resp.longitude;
          that.itemObj.wei = that.signy = resp.latitude;
          that.tip = '可打卡';
          that.control = '1';
        } else {
          that.$utils.Tools.loadHide();
          that.$utils.Tools.toastShow(_this3.$t('location.failed'));
          _this3.address = '';
          _this3.control = '0';
          _this3.tip = '定位失败';
        }
      });
      that.setTimeer = setTimeout(function () {
        if (!_this3.$utils.Store.getItem('address') && !_this3.$utils.Store.getItem('resp')) {
          _this3.$utils.Tools.loadHide();

          _this3.$utils.Tools.toastShow('获取定位失败，请检查手机GPS是否开启');

          _this3.address = '';
          _this3.control = '0';
          _this3.tip = '获取定位超时';
        }
      }, 10000);
    },
    setDtConfig: function setDtConfig() {
      var _this4 = this;

      var localUrl = window.location.href.split('#')[0];
      this.$api.DingTalk.getDtConfig(localUrl).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this4.$code.success) {
          _this4.$utils.Tools.toastShow(msg);
        } else {
          _this4.$utils.DingTalk.getConfig(data);

          setTimeout(function () {
            _this4.onDtPosition();
          }, 500);
        }
      }).catch(function () {
        _this4.$utils.Tools.httpError();
      });
    },
    onDtPosition: function onDtPosition() {
      var _this5 = this;

      this.$utils.Tools.loadShow();
      var that = this;
      that.$utils.DingTalk.dtGetLocation('allmap', 14, false, function (resp) {
        _this5.$utils.Tools.loadHide();

        if (resp.flag === true) {
          that.address = resp.address;
          that.control = '0';
          that.$utils.Store.setItem('address', resp.address);
          that.$utils.Store.setItem('resp', JSON.stringify(resp));
          that.itemObj.address = that.address = resp.address;
          that.itemObj.jing = that.signx = resp.longitude;
          that.itemObj.wei = that.signy = resp.latitude;
          that.tip = '可打卡';
          that.control = '1';
        } else {
          that.$utils.Tools.loadHide();
          that.$utils.Tools.toastShow(_this5.$t('location.failed'));
          _this5.address = '';
          _this5.control = '0';
          _this5.tip = '定位失败';
        }
      });
      that.setTimeer = setTimeout(function () {
        if (!_this5.$utils.Store.getItem('address') && !_this5.$utils.Store.getItem('resp')) {
          _this5.$utils.Tools.loadHide();

          _this5.$utils.Tools.toastShow('获取定位失败，请检查手机GPS是否开启');

          _this5.address = '';
          _this5.control = '0';
          _this5.tip = '获取定位超时';
        }
      }, 10000);
    },
    getBanci: function getBanci() {
      var _this6 = this;

      this.$api.Attence.getBanci({
        banciId: 1
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this6.$code.success) {
          _this6.$utils.Tools.toastShow(msg);
        } else {
          _this6.date = data;

          for (var i = 0; i < _this6.date.length; i++) {
            for (var key in _this6.date[i]) {
              if (key !== 'workType') {
                _this6.date[i][key] = _this6.$utils.DateUtils.formatScmDate(_this6.date[i][key]);
              }
            }

            if (i === 0) {
              _this6.workData[0].time = _this6.date[i].startWork;
              _this6.workData[1].time = _this6.date[i].endWork;
            }
          }
        }
      }).catch(function () {
        _this6.$utils.Tools.httpError();
      });
    },
    getToday: function getToday() {
      var _this7 = this;

      this.workData[0].oktime = [];
      this.workData[1].oktime = [];
      this.$api.Attence.getToday({
        userSerial: this.userSerial,
        dates: this.$utils.DateUtils.getFullDate(this.currDate)
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this7.$code.success) {
          _this7.$utils.Tools.toastShow(msg);
        } else {
          for (var i = 0; i < data.length; i++) {
            var timeSource = data[i].sj;
            var fmtTime = '';

            if (timeSource.length === 19) {
              fmtTime = _this7.$utils.DateUtils.formatDate(timeSource, 'HH:mm:ss');
            } else {
              fmtTime = _this7.$utils.DateUtils.formatScmTime(timeSource);
            }

            if (+data[i].fx === 1) {
              _this7.workData[0].oktime.push({
                time: fmtTime,
                bh: data[i].bh
              });

              _this7.ifstart[0] = true;
            } else if (+data[i].fx === 2) {
              _this7.workData[1].oktime.push({
                time: fmtTime,
                bh: data[i].bh
              });

              _this7.ifstart[1] = true;
            }
          }

          _this7.$nextTick(function () {
            var divs = document.getElementsByClassName('div-record');

            var _iterator = _createForOfIteratorHelper(divs),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;
                item.scrollTop = item.scrollHeight;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          });
        }
      }).catch(function () {
        _this7.$utils.Tools.httpError();
      });
    }
  },
  computed: {},
  created: function created() {
    this.userSerial = this.$utils.Store.getItem('userSerial');
    this.getSysDate(); // this.getBanci();
  },
  mounted: function mounted() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // await this.getRange();
              _this8.$utils.Tools.getEnv(function (res) {
                if (res === 0 || res === 1) {
                  _this8.setConfig();

                  _this8.interval = setInterval(function () {
                    _this8.onPosition();
                  }, 60000);
                } else {
                  _this8.setDtConfig();

                  _this8.interval = setInterval(function () {
                    // this.setConfig();
                    _this8.onDtPosition();
                  }, 60000);
                }
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
    clearTimeout(this.setTimeer);
    this.$utils.Tools.loadHide();
  }
};